import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/axios";

import {
    DashboardFetch,
    IARDashboardAging,
    IARDashboardCustomerDelay,
    IARDashboardCustomerList,
    IARDashboardCustomerDue,
    IARDashboardDSOTrend,
    IARDashboardInvoices,
    IARDashboardNumbers,
    IARDashboardSales,
} from "../../utils/ARDashboard.types";

/**
 * Fetch AP Dashboard numbers async thunk.
*/
export const fetchAPDashboardNumbers = createAsyncThunk(
    'dashboard/numbers/ap',
    async ({accountId,  params}:DashboardFetch): Promise<IARDashboardNumbers> => {
        let queryParam = (params)? `${params}`: ''
        const response = await axios.get(`/api/v1/dashboard/ap/numbers/${accountId}?${queryParam}`);

        return response.data;
    }
);

/**
 * Fetch AP Dashboard sales async thunk.
*/
export const fetchAPDashboardSales = createAsyncThunk(
    'dashboard/sales/ap',
    async ({accountId,  params}:DashboardFetch): Promise<IARDashboardSales> => {
        let queryParam = (params)? `${params}`: ''
        const response = await axios.get(`/api/v1/dashboard/ap/purchases/${accountId}?${queryParam}`);

        return response.data;
    }
);

/**
 * Fetch AP Dashboard invoices async thunk.
*/
export const fetchAPDashboardInvoices = createAsyncThunk(
    'dashboard/invoices/ap',
    async ({accountId,  params}:DashboardFetch): Promise<IARDashboardInvoices> => {
        let queryParam = (params)? `${params}`: ''
        const response = await axios.get(`/api/v1/dashboard/ap/invoices/${accountId}?${queryParam}`);

        return response.data;
    }
);

/**
 * Fetch AP Dashboard aging async thunk.
*/
export const fetchAPDashboardAging = createAsyncThunk(
    'dashboard/aging/ap',
    async ({accountId,  params}:DashboardFetch): Promise<IARDashboardAging> => {
        let queryParam = (params)? `${params}`: ''
        const response = await axios.get(`/api/v1/dashboard/ap/aging/${accountId}?${queryParam}`);

        return response.data;
    }
);

/**
 * Fetch AP Dashboard DSO trend async thunk.
*/
export const fetchAPDashboardDSOTrend = createAsyncThunk(
    'dashboard/dsotrend/ap',
    async ({accountId,  params}:DashboardFetch): Promise<IARDashboardDSOTrend> => {
        let queryParam = (params)? `${params}`: ''
        const response = await axios.get(`/api/v1/dashboard/ap/dso-trend/${accountId}?${queryParam}`);

        return response.data;
    }
);

/**
 * Fetch AP Dashboard Top Customers with amount due async thunk.
*/
export const fetchAPDashboardCustomersDue = createAsyncThunk(
    'dashboard/customerdue/ap',
    async ({accountId,  params}:DashboardFetch): Promise<IARDashboardCustomerDue> => {
        let queryParam = (params)? `${params}`: ''
        const response = await axios.get(`/api/v1/dashboard/ap/customer-due/${accountId}?${queryParam}`);

        return response.data;
    }
);

/**
 * Fetch AP Dashboard Top Customers list with amount due async thunk.
*/
export const fetchAPDashboardCustomersListDue = createAsyncThunk(
    'dashboard/customerListdue/ap',
    async ({accountId,  params}:DashboardFetch): Promise<IARDashboardCustomerList> => {
        let queryParam = (params)? `${params}`: ''
        const response = await axios.get(`/api/v1/dashboard/ap/customer-list-due/${accountId}?${queryParam}`);

        return response.data;
    }
);

/**
 * Fetch AP Dashboard Top Customers with delay async thunk.
*/
export const fetchAPDashboardCustomersDelay = createAsyncThunk(
    'dashboard/customerdelay/ap',
    async ({accountId,  params}:DashboardFetch): Promise<IARDashboardCustomerDelay> => {
        let queryParam = (params)? `${params}`: ''
        const response = await axios.get(`/api/v1/dashboard/ap/customer-delay/${accountId}?${queryParam}`);

        return response.data;
    }
);

/**
 * Fetch AP Dashboard Customers with delay list async thunk.
*/
export const fetchAPDashboardListCustomersDelay = createAsyncThunk(
    'dashboard/customerdelaylist/ap',
    async ({accountId,  params}:DashboardFetch): Promise<IARDashboardCustomerList> => {
        let queryParam = (params)? `${params}`: ''
        const response = await axios.get(`/api/v1/dashboard/ap/customer-list-delay/${accountId}?${queryParam}`);

        return response.data;
    }
);

